(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ---- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  },{threshold:.14, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

  /* ---- dose ledger fill ---- */
  var ledger = document.getElementById('ledger');
  var lio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.querySelectorAll('.dose__fill').forEach(function(f,i){
        f.style.width = f.dataset.w + '%';   // final width now; invisible until .is-filled scales it in
        setTimeout(function(){ f.classList.add('is-filled'); }, reduce ? 0 : i*130);
      });
      lio.unobserve(e.target);
    });
  },{threshold:.25});
  if(ledger) lio.observe(ledger);

  /* ---- copy label ---- */
  var LABEL = [
    'ALPHA SERENITY — SUPPLEMENT FACTS',
    'Serving Size: 2 Veggie Capsules | Servings Per Container: 30',
    '',
    'Magnesium (as Magnesium Citrate) — 37.5mg — 9% DV',
    'Rhodiola Extract (Rhodiola rosea) (Root) (std. 1% Salidroside) — 400mg — **',
    'L-Theanine — 200mg — **',
    'Lemon Balm Extract 5:1 (Melissa officinalis) (Leaf) — 200mg — **',
    'Phosphatidylserine (std. to 20%) — 100mg — **',
    'Mucuna Pruriens Extract (Mucuna pruriens) (Seed) (std. 50% L-dopa) — 100mg — **',
    '',
    '** Daily Value not established.',
    'Other Ingredients: Cellulose (Vegetable Capsule), Organic Rice Hull, Magnesium Stearate, Silicon Dioxide.',
    'Allergen Warning: Soy (Phosphatidylserine). Manufactured in a facility which processes Milk, Egg, Fish, Shellfish, Tree Nut, Peanut, Wheat, Soy, and Sesame.'
  ].join('\n');

  document.querySelectorAll('.qbtn').forEach(function(b){
    b.addEventListener('click', function(){
      var q = b.dataset.q;
      var txt = LABEL + (q ? '\n\nQuestion: ' + q : '');
      navigator.clipboard.writeText(txt).then(function(){
        var tag = b.querySelector('b'), old = tag.textContent;
        b.setAttribute('aria-live','polite');
        tag.textContent = 'Copied ✓';
        setTimeout(function(){ tag.textContent = old; }, 1800);
      });
    });
  });

  /* ---- ticker pause (WCAG 2.2.2) ---- */
  var tt=document.getElementById('ttrack'), tp=document.getElementById('tpause');
  if(tp){ tp.addEventListener('click',function(){
    var paused=tt.classList.toggle('is-paused');
    tp.textContent = paused ? '▶' : '❚❚';
    tp.setAttribute('aria-label', paused ? 'Resume scrolling banner' : 'Pause scrolling banner');
  }); }

  /* ---- sticky buy bar ---- */
  var sticky = document.getElementById('sticky');
  var hero = document.getElementById('buy');
  var sio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ sticky.classList.toggle('is-on', !e.isIntersecting); });
  },{threshold:0});
  if(hero) sio.observe(hero);

  /* ---- Buy with Prime / Shop Promise widget skin ----
     Shopify injects <delivery-promise-wc data-strategy="add-to-cart-form-
     structural"> into #as-buy-form on the live domain only. Its internals
     live in an OPEN shadow root (verified 2026-08-01), so we append a
     stylesheet there: Prime button 46px, delivery estimate as a plain
     12px line (no box, border, or padding). Class names are the widget's
     own — if Shopify renames them the rules no-op and the widget simply
     renders in its stock style. */
  var buyForm = document.getElementById('as-buy-form');
  function skinPromise(host){
    if(!host || host.__asSkinned) return;
    var tries = 0;
    (function attempt(){
      var sr = host.shadowRoot;
      if(!sr){ if(++tries < 40) setTimeout(attempt, 250); return; }
      if(host.__asSkinned) return;
      host.__asSkinned = true;
      var st = document.createElement('style');
      /* !important: the widget's [data-theme='DARK'] background rule
         out-specifies a bare class selector (verified live 2026-08-01). */
      st.textContent =
        '.BuyWithPrimeButton__buy-with-prime-button{box-sizing:border-box;height:46px;padding:10px 6px 6px}' +
        '.ContainerCommon__Container{background:transparent!important;border:0!important;border-radius:0!important;padding:0!important;font-size:12px!important;line-height:1.5!important}' +
        '.ContainerCommon__Container .Text__Text{font-size:12px!important}';
      sr.appendChild(st);
    })();
  }
  if(buyForm){
    skinPromise(buyForm.querySelector('delivery-promise-wc'));
    new MutationObserver(function(){
      skinPromise(buyForm.querySelector('delivery-promise-wc'));
    }).observe(buyForm, {childList:true, subtree:true});
  }
})();
